import { Grid } from '@material-ui/core'
import React from 'react'
import { useStyle } from './TagsStyle'
export default function Tags() {
    const style = useStyle()

    return (
        <div style={{  }}>
            <Grid container style={{width:"70%"}}> 
                <Grid xl={4} lg={4} md={4} sm={12} xs={12}>
                    <div>
                        <div className={style.keytxt}>
                            Key
                        </div>
                        <input type="text" className={style.tagInput} />
                        <div className={style.txt}>Max 64 alpha-numberic characters,<br /> underscores, deshes or dots</div>
                    </div>
                </Grid>
                <Grid xl={4} lg={4} md={4} sm={12} xs={12}>
                    <div>
                        <div className={style.keytxt}>
                            Value
                        </div>
                        <input type="text" className={style.tagInput} />
                        <div className={style.txt}>Max 128 characters</div>
                    </div>
                </Grid>
                <Grid xl={4} lg={4} md={4} sm={12} xs={12}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <button className={style.addButton}>Add</button>
                    </div>
                </Grid>
            </Grid>



        </div>
    )
}
